import { Button } from "playbook-ui";

const PbButton = Button;

export default PbButton
